<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="toggleMinimize()"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  @if (showEntityLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  
  @if (!showEntityLoader) {
<div>
    <div class="panel panel-default">
      <div class="panel-body">
        <form [formGroup]="thresholdForm" (ngSubmit)="rowData ? update() : save()">
            
          <!-- Row 1: Schema Owner, Target Table Name, Refresh Type (Create) -->
          @if (!rowData || !rowData.TABLE_ID) {
<div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="schema-owner"><b>Schema Owner<sup>*</sup>:</b></label>
                <input type="text" 
                       class="form-control" 
                       id="schema-owner" 
                       formControlName="SCHEMA_OWNER"
                       readonly>
                @if (thresholdEntity.SCHEMA_OWNER_NOT_VALID && !thresholdEntity.SCHEMA_OWNER) {
<small class="text-danger" 
                      >
                  Please provide Schema Owner
                </small>
}
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="target-table-name"><b>Target Table Name<sup>*</sup>:</b></label>
                <input type="text" 
                       class="form-control" 
                       id="target-table-name" 
                       formControlName="TABLE_NAME"
                       placeholder="Select Table Name">
                @if (thresholdEntity.TABLE_NAME_NOT_VALID && !thresholdEntity.TABLE_NAME) {
<small class="text-danger" 
                      >
                  Please provide Target Table Name
                </small>
}
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group" style="max-height: 200px;">
                <label for="refresh-type"><b>Refresh Type<sup>*</sup>:</b></label>
                <input list="refreshTypeList" 
                       class="form-control" 
                       id="refresh-type" 
                       formControlName="REFRESH_TYPE"
                       placeholder="Select Refresh Type" 
                       required/>
                <datalist id="refreshTypeList">
                  @for (refreshType of allRefreshTypes; track trackByIndex(i, refreshType); let i = $index) {
<option 
                          [value]="refreshType.REFRESH_TYPE" 
                          [attr.data-index]="i">
                    {{refreshType.REFRESH_TYPE}}
                  </option>
}
                </datalist>
                @if (thresholdEntity.REFRESH_TYPE_NOT_VALID && !thresholdEntity.REFRESH_TYPE) {
<small class="text-danger" 
                      >
                  Please provide Refresh Type
                </small>
}
              </div>
            </div>
          </div>
}

          <!-- Edit Mode: Three Column Layout -->
          <!-- Row 1: Table ID, Schema Owner, Target Table Name -->
          @if (rowData && rowData.TABLE_ID) {
<div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="table-id"><b>Table ID<sup>*</sup>:</b></label>
                <input type="text" 
                       class="form-control" 
                       id="table-id" 
                       formControlName="TABLE_ID"
                       readonly>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="schema-owner-edit"><b>Schema Owner<sup>*</sup>:</b></label>
                <input type="text" 
                       class="form-control" 
                       id="schema-owner-edit" 
                       formControlName="SCHEMA_OWNER"
                       readonly>
                @if (thresholdEntity.SCHEMA_OWNER_NOT_VALID && !thresholdEntity.SCHEMA_OWNER) {
<small class="text-danger" 
                      >
                  Please provide Schema Owner
                </small>
}
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="target-table-name-edit"><b>Target Table Name<sup>*</sup>:</b></label>
                <input type="text" 
                       class="form-control" 
                       id="target-table-name-edit" 
                       formControlName="TABLE_NAME"
                       readonly>
                @if (thresholdEntity.TABLE_NAME_NOT_VALID && !thresholdEntity.TABLE_NAME) {
<small class="text-danger" 
                      >
                  Please provide Target Table Name
                </small>
}
              </div>
            </div>
          </div>
}

          <!-- Row 2: Refresh Type, Source Schema, Source Table Name -->
          @if (rowData && rowData.TABLE_ID) {
<div class="row">
            <div class="col-md-4">
              <div class="form-group" style="max-height: 200px;">
                <label for="refresh-type-edit"><b>Refresh Type<sup>*</sup>:</b></label>
                <input list="refreshTypeListEdit" 
                       class="form-control" 
                       id="refresh-type-edit" 
                       formControlName="REFRESH_TYPE"
                       placeholder="Select Refresh Type" 
                       required/>
                <datalist id="refreshTypeListEdit">
                  @for (refreshType of allRefreshTypes; track trackByIndex(i, refreshType); let i = $index) {
<option 
                          [value]="refreshType.REFRESH_TYPE" 
                          [attr.data-index]="i">
                    {{refreshType.REFRESH_TYPE}}
                  </option>
}
                </datalist>
                @if (thresholdEntity.REFRESH_TYPE_NOT_VALID && !thresholdEntity.REFRESH_TYPE) {
<small class="text-danger" 
                      >
                  Please provide Refresh Type
                </small>
}
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="source-schema-edit"><b>Source Schema<sup>*</sup>:</b></label>
                <input type="text" 
                       class="form-control" 
                       id="source-schema-edit" 
                       formControlName="SOURCE_SCHEMA">
                @if (thresholdEntity.SOURCE_SCHEMA_NOT_VALID && !thresholdEntity.SOURCE_SCHEMA) {
<small class="text-danger" 
                      >
                  Please provide Source Schema
                </small>
}
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="source-table-name-edit"><b>Source Table Name<sup>*</sup>:</b></label>
                <input type="text" 
                       class="form-control" 
                       id="source-table-name-edit" 
                       formControlName="SOURCE_TABLE_NAME">
                @if (thresholdEntity.SOURCE_TABLE_NAME_NOT_VALID && !thresholdEntity.SOURCE_TABLE_NAME) {
<small class="text-danger" 
                      >
                  Please provide Source Table Name
                </small>
}
              </div>
            </div>
          </div>
}

          <!-- Row 3: Table Type, From Tax Year, To Tax Year -->
          @if (rowData && rowData.TABLE_ID) {
<div class="row">
            <div class="col-md-4">
              <div class="form-group" style="max-height: 200px;">
                <label for="table-type-edit"><b>Table Type<sup>*</sup>:</b></label>
                <select class="form-control" 
                        id="table-type-edit" 
                        formControlName="TABLE_TYPE">
                  @for (tableType of allTableTypes; track trackByIndex(i, tableType); let i = $index) {
<option 
                          [value]="tableType.TABLE_TYPE" 
                          [attr.data-index]="i">
                    {{tableType.TABLE_TYPE}}
                  </option>
}
                </select>
                @if (thresholdEntity.TABLE_TYPE_NOT_VALID && !thresholdEntity.TABLE_TYPE) {
<small class="text-danger" 
                      >
                  Please provide Table Type
                </small>
}
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="from-tax-year-edit"><b>From Tax Year<sup>*</sup>:</b></label>
                <div class="input-group">
                  <input type="text" 
                         class="form-control" 
                         id="from-tax-year-edit" 
                         formControlName="FROM_TAX_YEAR"
                         [value]="fromTaxYear || ''"
                         placeholder="YYYY"
                         readonly/>
                  <span class="input-group-addon" 
                        (click)="openFromYearPicker()"
                        style="cursor: pointer;">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
                
                <!-- From Year Picker Popup -->
                <gtw-year-picker-popup
                  [selectedYear]="fromTaxYear"
                  [showPopup]="showFromYearPicker"
                  [minYear]="1900"
                  [maxYear]="9999"
                  [triggerElementId]="'from-tax-year-edit'"
                  (yearSelected)="onFromYearSelected($event)"
                  (popupClosed)="closeFromYearPicker()">
                </gtw-year-picker-popup>
                
                @if (thresholdEntity.FROM_TAX_YEAR_NOT_VALID && !thresholdEntity.FROM_TAX_YEAR) {
<small class="text-danger" 
                      >
                  Please provide From Tax Year
                </small>
}
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="to-tax-year-edit"><b>To Tax Year<sup>*</sup>:</b></label>
                <div class="input-group">
                  <input type="text" 
                         class="form-control" 
                         id="to-tax-year-edit" 
                         formControlName="TO_TAX_YEAR"
                         [value]="toTaxYear || ''"
                         placeholder="YYYY"
                         readonly/>
                  <span class="input-group-addon" 
                        (click)="openToYearPicker()"
                        style="cursor: pointer;">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
                
                <!-- To Year Picker Popup -->
                <gtw-year-picker-popup
                  [selectedYear]="toTaxYear"
                  [showPopup]="showToYearPicker"
                  [minYear]="1900"
                  [maxYear]="9999"
                  [triggerElementId]="'to-tax-year-edit'"
                  (yearSelected)="onToYearSelected($event)"
                  (popupClosed)="closeToYearPicker()">
                </gtw-year-picker-popup>
                
                @if (thresholdEntity.TO_TAX_YEAR_NOT_VALID && !thresholdEntity.TO_TAX_YEAR) {
<small class="text-danger" 
                      >
                  Please provide To Tax Year
                </small>
}
              </div>
            </div>
          </div>
}

          <!-- Row 4: Table Classification, Threshold Value -->
          @if (rowData && rowData.TABLE_ID) {
<div class="row">
            <div class="col-md-4">
              <div class="form-group" style="max-height: 200px;">
                <label for="table-classification-edit"><b>Table Classification<sup>*</sup>:</b></label>
                <select class="form-control" 
                        id="table-classification-edit" 
                        formControlName="TABLE_CLASSIFICATION">
                  @for (tableClass of allTableClasses; track trackByIndex(i, tableClass); let i = $index) {
<option 
                          [value]="tableClass.CLASSIFICATION_KEY" 
                          [attr.data-index]="i">
                    {{tableClass.CLASSIFICATION_DESC}}
                  </option>
}
                </select>
                @if (thresholdEntity.TABLE_CLASSIFICATION_NOT_VALID && !thresholdEntity.TABLE_CLASSIFICATION) {
<small class="text-danger" 
                      >
                  Please provide Table Classification
                </small>
}
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group" style="max-height: 200px;">
                <label for="threshold-value-edit-final"><b>Threshold Value<sup>*</sup>:</b></label>
                <select class="form-control" 
                        id="threshold-value-edit-final" 
                        formControlName="SRC_TO_TGT_VAR_THRESHOLD">
                  @for (thresholdValue of allThresholdValues; track trackByIndex(i, thresholdValue); let i = $index) {
<option 
                          [value]="thresholdValue.SRC_TO_TGT_VAR_THRESHOLD" 
                          [attr.data-index]="i">
                    {{thresholdValue.SRC_TO_TGT_VAR_THRESHOLD}}
                  </option>
}
                </select>
                @if (thresholdEntity.SRC_TO_TGT_VAR_THRESHOLD_NOT_VALID && !thresholdEntity.SRC_TO_TGT_VAR_THRESHOLD) {
<small class="text-danger" 
                      >
                  Please provide Threshold Value
                </small>
}
              </div>
            </div>
          </div>
}

          <!-- Row 2: Source Schema, Source Table Name, Table Type (Create) -->
          @if (!rowData || !rowData.TABLE_ID) {
<div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="source-schema"><b>Source Schema<sup>*</sup>:</b></label>
                <input type="text" 
                       class="form-control" 
                       id="source-schema" 
                       formControlName="SOURCE_SCHEMA"
                       readonly>
                @if (thresholdEntity.SOURCE_SCHEMA_NOT_VALID && !thresholdEntity.SOURCE_SCHEMA) {
<small class="text-danger" 
                      >
                  Please provide Source Schema
                </small>
}
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="source-table-name"><b>Source Table Name<sup>*</sup>:</b></label>
                <input type="text" 
                       class="form-control" 
                       id="source-table-name" 
                       formControlName="SOURCE_TABLE_NAME">
                @if (thresholdEntity.SOURCE_TABLE_NAME_NOT_VALID && !thresholdEntity.SOURCE_TABLE_NAME) {
<small class="text-danger" 
                      >
                  Please provide Source Table Name
                </small>
}
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group" style="max-height: 200px;">
                <label for="table-type"><b>Table Type<sup>*</sup>:</b></label>
                <select class="form-control" 
                        id="table-type" 
                        formControlName="TABLE_TYPE">
                  @for (tableType of allTableTypes; track trackByIndex(i, tableType); let i = $index) {
<option 
                          [value]="tableType.TABLE_TYPE" 
                          [attr.data-index]="i">
                    {{tableType.TABLE_TYPE}}
                  </option>
}
                </select>
                @if (thresholdEntity.TABLE_TYPE_NOT_VALID && !thresholdEntity.TABLE_TYPE) {
<small class="text-danger" 
                      >
                  Please provide Table Type
                </small>
}
              </div>
            </div>
          </div>
}


          <!-- Row 3: From Tax Year, To Tax Year, Table Classification, Threshold Value (Create) -->
          @if (!rowData || !rowData.TABLE_ID) {
<div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label for="from-tax-year-create"><b>From Tax Year<sup>*</sup>:</b></label>
                <div class="input-group">
                  <input type="text" 
                         class="form-control" 
                         id="from-tax-year-create" 
                         formControlName="FROM_TAX_YEAR"
                         [value]="fromTaxYear || ''"
                         placeholder="YYYY"
                         readonly/>
                  <span class="input-group-addon" 
                        (click)="openFromYearPicker()"
                        style="cursor: pointer;">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
                
                <!-- From Year Picker Popup -->
                <gtw-year-picker-popup
                  [selectedYear]="fromTaxYear"
                  [showPopup]="showFromYearPicker"
                  [minYear]="1900"
                  [maxYear]="9999"
                  [triggerElementId]="'from-tax-year-create'"
                  (yearSelected)="onFromYearSelected($event)"
                  (popupClosed)="closeFromYearPicker()">
                </gtw-year-picker-popup>
                
                @if (thresholdEntity.FROM_TAX_YEAR_NOT_VALID && !thresholdEntity.FROM_TAX_YEAR) {
<small class="text-danger" 
                      >
                  Please provide From Tax Year
                </small>
}
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="to-tax-year-create"><b>To Tax Year<sup>*</sup>:</b></label>
                <div class="input-group">
                  <input type="text" 
                         class="form-control" 
                         id="to-tax-year-create" 
                         formControlName="TO_TAX_YEAR"
                         [value]="toTaxYear || ''"
                         placeholder="YYYY"
                         readonly/>
                  <span class="input-group-addon" 
                        (click)="openToYearPicker()"
                        style="cursor: pointer;">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
                
                <!-- To Year Picker Popup -->
                <gtw-year-picker-popup
                  [selectedYear]="toTaxYear ? toTaxYear - 1 : null"
                  [showPopup]="showToYearPicker"
                  [minYear]="1900"
                  [maxYear]="9999"
                  [triggerElementId]="'to-tax-year-create'"
                  (yearSelected)="onToYearSelected($event)"
                  (popupClosed)="closeToYearPicker()">
                </gtw-year-picker-popup>
                
                @if (thresholdEntity.TO_TAX_YEAR_NOT_VALID && !thresholdEntity.TO_TAX_YEAR) {
<small class="text-danger" 
                      >
                  Please provide To Tax Year
                </small>
}
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" style="max-height: 200px;">
                <label for="table-classification"><b>Table Classification<sup>*</sup>:</b></label>
                <select class="form-control" 
                        id="table-classification" 
                        formControlName="TABLE_CLASSIFICATION">
                  @for (tableClass of allTableClasses; track trackByIndex(i, tableClass); let i = $index) {
<option 
                          [value]="tableClass.CLASSIFICATION_KEY" 
                          [attr.data-index]="i">
                    {{tableClass.CLASSIFICATION_DESC}}
                  </option>
}
                </select>
                @if (thresholdEntity.TABLE_CLASSIFICATION_NOT_VALID && !thresholdEntity.TABLE_CLASSIFICATION) {
<small class="text-danger" 
                      >
                  Please provide Table Classification
                </small>
}
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group" style="max-height: 200px;">
                <label for="threshold-value-create"><b>Threshold Value<sup>*</sup>:</b></label>
                <select class="form-control" 
                        id="threshold-value-create" 
                        formControlName="SRC_TO_TGT_VAR_THRESHOLD">
                  @for (thresholdValue of allThresholdValues; track trackByIndex(i, thresholdValue); let i = $index) {
<option 
                          [value]="thresholdValue.SRC_TO_TGT_VAR_THRESHOLD" 
                          [attr.data-index]="i">
                    {{thresholdValue.SRC_TO_TGT_VAR_THRESHOLD}}
                  </option>
}
                </select>
                @if (thresholdEntity.SRC_TO_TGT_VAR_THRESHOLD_NOT_VALID && !thresholdForm.get('SRC_TO_TGT_VAR_THRESHOLD')?.value) {
<small class="text-danger" 
                      >
                  Please provide Threshold Value
                </small>
}
              </div>
            </div>
          </div>
}


        </form>
      </div>
    </div>
  </div>
}
</div>

<!-- Footer with standardized buttons -->
<div class="modal-footer">
  <button
    class="save-button"
    type="button"
    [disabled]="isSaving || isSavingUpdate"
    (click)="(!rowData || !rowData.TABLE_ID) ? save() : update()"
  >
    @if (isSaving || isSavingUpdate) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    @if (!rowData || !rowData.TABLE_ID) {
<span>Create</span>
}
    @if (rowData && rowData.TABLE_ID) {
<span>Update</span>
}
  </button>

  @if (rowData && rowData.TABLE_ID) {
<button class="delete-button" type="button" [disabled]="isSavingDelete"
    (click)="delete()">
    @if (isSavingDelete) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Delete
  </button>
}

  <button class="reset-button" type="button" (click)="reset()">Reset</button>

  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
